import { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import accountActions from "../../../store/actions/accounts/account.actions";
import toastService from "../../../services/alerts/toast.service";
import "./loginPageComponent.scss"; // Import SCSS file
import TextInputElementComponent from "../../../components/elements/inputElements/TextInputElementComponent";
import textInputModel from "../../../models/elements/inputElements/textInput.model";
import validationHelper from "../../../helpers/validation.helper";
import { useNavigate } from "react-router-dom";

export const LoginPageComponent = ({ accountActions }) => {
  const defaultCredentials = { email: "", password: "" };
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState(defaultCredentials);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!credentials.email) newErrors.email = "Email is required";
    if (!credentials.password) newErrors.password = "Password is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCredentials({ ...credentials, [name]: value });
    setErrors({ ...errors, [name]: "" }); // Clear error on change
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      return;
    }

    try {
      const response = await accountActions.login(credentials);
      if (!validationHelper.validateHttpResponse(response?.data)) {
        setErrors({ ...errors, general: "שגיאה בהתחברות, אנא נסה שנית " });
        return;
      }
      console.log("🚀 ~ handleLogin ~ !validationHelper.validateHttpResponse(response):", !validationHelper.validateHttpResponse(response));
      toastService.success("התחברת בהצלחה");
      navigate("/");
    } catch (error) {
      toastService.error("Login failed. Please check your credentials.");
    }
  };

  const getEmailInputElement = () => {
    const props = {
      ...textInputModel,
      name: "email",
      value: credentials.email,
      customDesignClass: "discountCuponInputContainer",
      placeholder: 'הזן כתובת דוא"ל',
      onChange: handleInputChange,
      type: "email",
      error: errors.email,
    };
    return <TextInputElementComponent props={props} />;
  };

  const getPasswordInputElement = () => {
    const props = {
      name: "password",
      value: credentials.password,
      customDesignClass: "discountCuponInputContainer",
      placeholder: "הזן סיסמה",
      onChange: handleInputChange,
      type: "password",
      error: errors.password,
    };
    return <TextInputElementComponent props={props} />;
  };
  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        <h2 className="login-title">כניסת משתמש</h2>
        {getEmailInputElement()}
        {getPasswordInputElement()}

        <button type="submit" className="primaryButton">
          התחבר
        </button>
        <span>{errors.general}</span>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userReducer: state.userReducer,
  websiteReducer: state.websiteReducer,
});

const mapDispatchToProps = (dispatch) => ({
  accountActions: bindActionCreators(accountActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPageComponent);
